
import React from 'react'
import DivisionListTable from './components/DivisionListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const DivisionList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Division List</HeadingOne>
                    <AddItemBtn url="division-add" title="Create Division" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <DivisionListTable />
            </div>
        </PageBody>
    );
};

export default DivisionList;
